import { render, staticRenderFns } from "./confirmation.page.vue?vue&type=template&id=5476085e"
import script from "./confirmation.page.vue?vue&type=script&lang=js"
export * from "./confirmation.page.vue?vue&type=script&lang=js"
import style0 from "./confirmation.page.vue?vue&type=style&index=0&id=5476085e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports